
export const uncapitalize = <T extends string>(str: T): Uncapitalize<T> => {
  return `${str.charAt(0).toLowerCase()}${str.slice(1)}` as Uncapitalize<T>
}
